import { useCallback } from "react";

export const BUG_REPORT_URL =
  "https://airtable.com/app0oALHD7UJqGiF5/pagEsPybKBhtg4Nc7/form";

export const useReportBug = () =>
  useCallback(() => {
    window.open(BUG_REPORT_URL, "_blank");
  }, []);
